// extracted by mini-css-extract-plugin
export default {"square__title":"Square_square__title__dRDsJ","square":"Square_square__gzv6O"};